import Link from "next/link";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useRouter } from "next/router";
import 'react-toastify/dist/ReactToastify.css';
import { FaShoppingCart, FaHeart, FaUser, FaSignOutAlt, FaBell } from "react-icons/fa";
import api from '@api/Apis'
import NavBarStyle from "./NavBarStyle";
import classNames from 'classnames';
import NotFication, { WishListNotFication, LogoutNav, MenuDropDownPop } from "./NotFicationLogout";
import NumberFormatComp from "@Components/Common/NumberFormatComp";
import ViewCartPopup from "@Components/ViewCartPopup";
import TemporaryDrawer from "./Drawer";
import { Button } from "@mui/material";
import SignUpRefferalPopUp from "src/pages/[page]/signup/ReviewPage/SignUpRefferalPopUp";
import LoginPopup from "@Components/Common/LoginPopup";
import parse from 'html-react-parser';

function buildMobileNavSections(menuData) {
    const shop = [];
    const learn = [{ title: "FAQs", url: "/faq", check: false }];
    const seenShop = new Set();
    const allowedShopMatchers = [
        /^super\s*prime\s*120$/i,
        /^maritime\b.*\b180$/i,
        /^maritime.*prime.*180$/i,
        /^silverkaire\s*colloidal$/i,
        /^biotickaire\+$/i,
        /^shop\s*all$/i,
    ];

    const mobileShopFallbacks = [
        { title: "Super Prime 120", url: "/product/Super_Prime_120/8", check: false },
        { title: "Maritime Prime 180", url: "/product/Maritime_Prime_180/4", check: false },
        { title: "SilverKaire Colloidal", url: "/product/SilverKaire_(8oz)/7", check: false },
        { title: "BioticKaire+", url: "/product/BioticKaire+/35", check: false },
        { title: "Shop All", url: "/allProduct", check: false },
    ];

    const shopSortRank = (title = "") => {
        const t = String(title).toLowerCase();
        if (/super\s*prime\s*120/.test(t)) return 0;
        if (/maritime/.test(t) && /180/.test(t)) return 1;
        if (/silverkaire/.test(t) && /colloidal/.test(t)) return 2;
        if (/biotickaire\+/.test(t) || /biotic\s*kaire\+/.test(t)) return 3;
        if (/shop\s*all/.test(t)) return 4;
        return 99;
    };

    const isOriginalPycnogenol = (title = "", url = "") => {
        const t = String(title).toLowerCase();
        const u = String(url).toLowerCase();
        const hasOriginal = /orig/i.test(t);
        const hasPycnogenol = /pycnogen/i.test(t) || /pycnogen/i.test(u);
        return hasOriginal && hasPycnogenol;
    };

    const hasOriginalPycnogenolLearn = (items) =>
        items.some((l) => isOriginalPycnogenol(l.title, l.url));

    const pushShop = (item) => {
        if (!item?.title) return;
        const normalizedTitle = item.title.trim();
        const isAllowed = allowedShopMatchers.some((re) => re.test(normalizedTitle));
        if (!isAllowed) return;
        const key = `${item.title}|${item.url}`;
        if (seenShop.has(key)) return;
        seenShop.add(key);
        shop.push(item);
    };

    (menuData || []).forEach((item) => {
        const { title, data, url, check } = item;
        if (Array.isArray(data) && data.length > 0) {
            data.forEach((sub) => {
                if (!sub?.title) return;
                if (isOriginalPycnogenol(sub.title, sub.url)) {
                    learn.push({ title: sub.title, url: sub.url, check: sub.check });
                } else {
                    pushShop({ title: sub.title, url: sub.url, check: sub.check });
                }
            });
            return;
        }
        if (isOriginalPycnogenol(title, url)) {
            learn.push({ title, url, check });
            return;
        }
        if (title && /shop\s*all/i.test(title)) {
            pushShop({ title, url, check });
        }
    });

    const hasShopAll = shop.some((s) => /shop\s*all/i.test(s.title));
    if (!hasShopAll) {
        pushShop({ title: "Shop All", url: "/allProduct", check: false });
    }

    const shopAllIdx = shop.findIndex((s) => /shop\s*all/i.test(s.title));
    if (shopAllIdx >= 0 && shopAllIdx !== shop.length - 1) {
        const [sa] = shop.splice(shopAllIdx, 1);
        shop.push(sa);
    }

    mobileShopFallbacks.forEach((fb) => {
        const rank = shopSortRank(fb.title);
        if (rank >= 99) return;
        const hasSlot = shop.some((s) => shopSortRank(s.title) === rank);
        if (!hasSlot) {
            shop.push({ ...fb });
        }
    });

    shop.sort((a, b) => shopSortRank(a.title) - shopSortRank(b.title));

    const learnDedup = [];
    const seenLearn = new Set();
    learn.forEach((l) => {
        const key = `${l.title}|${l.url}`;
        if (!seenLearn.has(key)) {
            seenLearn.add(key);
            learnDedup.push(l);
        }
    });

    if (!hasOriginalPycnogenolLearn(learnDedup)) {
        learnDedup.push({
            title: "The Original Pycnogenol®",
            url: "/pycnogenol",
            check: false,
        });
    }

    learnDedup.sort((a, b) => {
        const aFaq = /^faqs$/i.test((a.title || "").trim());
        const bFaq = /^faqs$/i.test((b.title || "").trim());
        if (aFaq && !bFaq) return -1;
        if (!aFaq && bFaq) return 1;
        return 0;
    });

    return { shopItems: shop, learnItems: learnDedup };
}

const NavBar = (props) => {
    const [allcategory, setallcategory] = useState();
    const [AddClass, setAddClass] = useState(false);
    const [menuData, setMenuData] = useState([]);
    const [token, setToken] = useState('');
    const [open, setOpen] = useState(false);
    const popRef = useRef(null);
    const [getDomain, setDomain] = useState();
    const router = useRouter();
    const [isActiveMobile, setIsActiveMobile] = useState("");
    const [openLoginPopup, setOpenLoginPopup] = useState(false);
    const store = (router?.query?.page) ? router?.query?.page : 'us';
    const isMounted = useRef(true);

    useEffect(() => {
        const fetchBanners = async () => {
            props.setBannerLoader(true);
            try {
                const res = await api.getAllBannersApi('us');
                props.setbannerData(res?.data?.Promotions || []);
            } catch (error) {
                console.error('Failed to fetch banners:', error);
            } finally {
                props.setBannerLoader(false);
            }
        };

        fetchBanners().catch(e => {
            console.error('Unhandled error in fetchBanners:', e);
            props.setBannerLoader(false);
        });
    }, []);


    const _menuSectionFunction = async () => {
        try {
            const response = await api.MenuSectionOption();
            if (isMounted.current && response?.status === 200 && response?.data?.code === 1) {
                setMenuData(response?.data?.menu_data);
            }
        } catch (error) {
            console.log('Error fetching menu data:', error);
        }
    };

    useEffect(() => {
        isMounted.current = true;
        api.getAllCategory(store)
            .then(res => {
                if (isMounted.current) {
                    setallcategory(res?.data?.categories);
                }
            });

        _menuSectionFunction();
        return () => {
            isMounted.current = false;
        };
    }, []);



    useEffect(() => {
        const data = localStorage.getItem("Token");
        setToken(data);
        const dataref = JSON.parse(localStorage.getItem('correctRefferal'));
        setDomain(dataref ? props?.correctRefferal?.data?.name : dataref?.data?.name);
    }, [props?.correctRefferal, router]);


    const showlogin = () => {
        setAddClass(false);
        props.setoldpath(router.asPath);
        router.push(`/us/login`);
        if (router.push(`/us/login`)) {
            setTimeout(() => {
                setOpenLoginPopup(true);
            }, 2000);
        }
    }

    const [countryState, setCountryState] = useState({ popUp: false, value: "USA" });
    const [languageState, setLanguageState] = useState({ popUp: false, value: "ENG" });

    const toggleDrawer = (section) => {
        if (section === "Country") {
            setCountryState({ ...countryState, popUp: true });
        } else {
            setLanguageState({ ...languageState, popUp: true });
        }
    };

    const _setValues = (section, value) => {
        if (section === "Country") {
            setCountryState({ value, popUp: false });
            try {
                localStorage.setItem("selectedCountry", value);
            } catch (e) {
                // ignore persistence errors
            }
        } else {
            setLanguageState({ value, popUp: false });
            try {
                localStorage.setItem("selectedLanguage", value);
            } catch (e) {
                // ignore persistence errors
            }
        }
    };

    useEffect(() => {
        try {
            const savedCountry = localStorage.getItem("selectedCountry");
            const savedLanguage = localStorage.getItem("selectedLanguage");
            if (savedCountry) {
                setCountryState({ popUp: false, value: savedCountry });
            }
            if (savedLanguage) {
                setLanguageState({ popUp: false, value: savedLanguage });
            }
        } catch (e) {
            // ignore read errors
        }
    }, []);

    // const productPromoTopBanners = props?.bannerData
    //     ?.filter(promotion => promotion?.promotion_type === "Promotions_On_Header")
    //     ?.flatMap(promotion => {
    //         if (Array.isArray(promotion?.banners)) {
    //             return promotion?.banners.filter(banner => banner?.is_active);
    //         }
    //         return [];
    //     }) ?? [];

    const productPromoTopBanners = Array.isArray(props?.bannerData) ? props.bannerData
        .filter(promotion => promotion?.promotion_type === "Promotions_On_Header")
        .reduce((acc, promotion) => {
            if (Array.isArray(promotion?.banners)) {
                const activeBanners = promotion.banners.filter(banner => banner?.is_active);
                return acc.concat(activeBanners);
            }
            return acc;
        }, [])
        : [];
    const currentSavedCountry = typeof window !== "undefined" ? localStorage.getItem("selectedCountry") : null;

    const mobileSections = useMemo(() => buildMobileNavSections(menuData), [menuData]);

    const handleMobileNavClick = (e, url, check) => {
        e.preventDefault();
        const u = (url || "").trim();
        const urlToNavigate = u === "/" ? "/" : `/${store}${u}`;
        setAddClass(false);
        if (check) {
            window.open(urlToNavigate, "_blank");
        } else {
            props?.setInnerLoader?.(true);
            router.push(urlToNavigate);
        }
    };

    return (
        <>
            <div className="main-header-section">
                <NavBarStyle image="https://admin.shopkaire.com/media/images/headerbgnew.jpg">
                    <div className="header-main-wrapper">
                        <>
                            <div className="shipping-banner">
                                <p className="shipping-content">NEW SHIPPING OPTIONS <span>+ FREE SHIPPING</span> ON $250+ ORDERS — US ONLY!</p>
                            </div>
                        </>

                        {productPromoTopBanners?.map((banner, index) => (
                            <div key={banner.id} className="promotions-bogo-banner d-flex">
                                {banner.banner_image &&
                                    <div className="promotions-banner">
                                        <img
                                            src={process.env.API_URL + banner.banner_image}
                                            alt={banner.text_heading}
                                            style={{ backgroundColor: banner.background_color }}
                                            loading="eager"
                                        />
                                    </div>
                                }
                                {banner?.text_content && (
                                    <div className='banner-promotion'>
                                        <h3
                                            style={{ color: banner?.text_color, backgroundColor: banner?.background_color }}
                                            dangerouslySetInnerHTML={{ __html: banner?.text_content }}
                                        />
                                    </div>
                                )}


                            </div>
                        ))}
                        <div className="header-section">
                            <div className="upper_lower_div">
                                <div className="d-flex">
                                    <div className="broughtby">
                                        {getDomain &&
                                            <>
                                                <span>Brought to you by:</span>
                                                <span className="name-brought"> {getDomain}</span>
                                            </>
                                        }
                                    </div>
                                    <div className="usa_country">
                                        <button onClick={() => toggleDrawer("Country")}>{countryState?.value}</button>
                                        <button onClick={() => toggleDrawer("Language")}>{languageState?.value}</button>
                                    </div>
                                </div>
                            </div>

                            <nav className="container navbar navbar-default">
                                <div className="navbar-header">
                                    <button
                                        type="button"
                                        className={classNames("navbar-toggle", "collapsed", "mobile-menu-toggle-btn", {
                                            "is-open": AddClass,
                                        })}
                                        data-toggle="collapse"
                                        data-target="#navbar-collapse-1"
                                        aria-expanded={AddClass}
                                        onClick={() => setAddClass(!AddClass)}
                                    >
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>

                                    <Link className="nav-link" href="/">
                                        <a className="navbar-brand">
                                            <img src="/images/Shop_Kaire.png" alt="Logo" loading="eager" />
                                        </a>
                                    </Link>
                                </div>

                                <div
                                    className={classNames("collapse navbar-collapse", {
                                        open_collapse_nav: AddClass,
                                        hide: !AddClass,
                                    })}
                                    id="navbar-collapse-1"
                                >
                                    <div className="nav-collapse-desktop">
                                        <ul className="nav navbar-nav navbar-left">
                                            {menuData?.map(({ title, data, url, check }, index) => (
                                                <MenuDropDownPop
                                                    title={title}
                                                    url={url}
                                                    innerData={data}
                                                    key={index + 1}
                                                    check={check}
                                                    setAddClass={setAddClass}
                                                    setIsActive={setIsActiveMobile}
                                                    isActive={isActiveMobile}
                                                    setInnerLoader={props?.setInnerLoader}
                                                />
                                            ))}
                                        </ul>
                                        <div className="upper_lower_div">
                                            <div className="d-flex">
                                                <div className="broughtby">
                                                    {getDomain &&
                                                        <>
                                                            <span>Brought to you by:</span>
                                                            <span className="name-brought"> {getDomain}</span>
                                                        </>
                                                    }
                                                </div>
                                                <div className="usa_country">
                                                    <button onClick={() => toggleDrawer("Country")}>{countryState?.value}</button>
                                                    <button onClick={() => toggleDrawer("Language")}>{languageState?.value}</button>
                                                </div>
                                            </div>
                                            <ul
                                                className="nav navbar-nav navbar-right"
                                                onClick={() => {
                                                    props?.updatecartdata(true);
                                                }}
                                            >
                                                <li>
                                                    {props.isLogin || token ? (
                                                        <div className="dashboard_div">
                                                            <Link className="nav-link" href={`/${store}/user/dashboard`}>
                                                                <a onClick={() => setAddClass(false)}>
                                                                    <div className="account_title font_change">My Account</div>
                                                                    <div className="account_icon font_change">
                                                                        <FaUser />
                                                                    </div>
                                                                </a>
                                                            </Link>
                                                            <LogoutNav
                                                                store={store}
                                                                section="from_navBar_section"
                                                                {...props}
                                                                key="NavbarSection3"
                                                                token={token}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="login_signin">
                                                            <a
                                                                onClick={showlogin}
                                                                style={{ cursor: "pointer", marginTop: "2px" }}
                                                                className="font_change"
                                                            >
                                                                Login
                                                            </a>
                                                        </div>
                                                    )}
                                                </li>

                                                <li className="view_cart_section" onClick={() => setAddClass(false)}>
                                                    <Link className="" href={`/${store}/cart/viewCart`}>
                                                        <div className="dashboard_div">
                                                            <a>
                                                                <div
                                                                    className="cart_title font_change"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    View Cart
                                                                </div>
                                                                <div className="icon-box-cart">
                                                                    <FaShoppingCart />
                                                                    {props?.cartdata?.products?.length > 0 && props?.counts && (
                                                                        <span>{props?.counts ? props?.counts : 0}</span>
                                                                    )}
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </Link>

                                                    <ul className="dropdown-popup_viewCart">
                                                        {props?.cartdata?.products ? (
                                                            <>
                                                                {props?.cartdata?.products?.map((productdata, index) => (
                                                                    <li className="" key={index + 1}>
                                                                        <div className="view_cart_div">
                                                                            {productdata?.product?.main_image ? (
                                                                                <img
                                                                                    src={`${process.env.API_URL}${productdata.product?.main_image}`}
                                                                                    alt={productdata?.product?.name}
                                                                                    loading="eager"
                                                                                />
                                                                            ) : (
                                                                                <img src="/images/no-image.jpg" alt="No Image" />
                                                                            )}
                                                                        </div>
                                                                        <div className="txt">
                                                                            {productdata?.variant === null ? (
                                                                                <>
                                                                                    {productdata?.product.name} <br />
                                                                                    Qty:{productdata?.quantity} <br />
                                                                                    <NumberFormatComp
                                                                                        value={parseFloat(
                                                                                            props?.cartdata?.products?.[0]?.is_autoship
                                                                                                ? productdata?.product?.autoship_cost_price *
                                                                                                productdata?.quantity
                                                                                                : productdata?.product?.cost_price *
                                                                                                productdata?.quantity
                                                                                        ).toFixed(2)}
                                                                                    />
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    {productdata?.product.name}- {productdata?.variant?.name} <br />
                                                                                    Qty:{productdata?.quantity} <br />
                                                                                    <NumberFormatComp
                                                                                        value={parseFloat(
                                                                                            props?.cartdata?.products?.[0]?.is_autoship
                                                                                                ? productdata?.variant?.autoship_cost_price *
                                                                                                productdata?.quantity
                                                                                                : productdata?.variant?.cost_price *
                                                                                                productdata?.quantity
                                                                                        ).toFixed(2)}
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                                <div className="view_cart_action">
                                                                    <Button onClick={() => router.push(`/${store}/cart/viewCart`)}>
                                                                        View Cart
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <p className="cart_empty">Cart is empty</p>
                                                        )}
                                                    </ul>
                                                </li>

                                                <WishListNotFication store={store} section="from_navBar_section" {...props} key="NavbarSection2" />
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="nav-collapse-mobile">
                                        <div className="mobile-nav-section">
                                            <h3 className="mobile-nav-heading">SHOP</h3>
                                            <ul className="mobile-nav-list">
                                                {mobileSections.shopItems.map((row, idx) => (
                                                    <li key={`shop-${idx}`}>
                                                        <a
                                                            href="#"
                                                            className="mobile-nav-link"
                                                            onClick={(e) => handleMobileNavClick(e, row.url, row.check)}
                                                        >
                                                            {row.title}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="mobile-nav-section">
                                            <h3 className="mobile-nav-heading">LEARN</h3>
                                            <ul className="mobile-nav-list">
                                                {mobileSections.learnItems.map((row, idx) => (
                                                    <li key={`learn-${idx}`}>
                                                        <a
                                                            href="#"
                                                            className="mobile-nav-link"
                                                            onClick={(e) => handleMobileNavClick(e, row.url, row.check)}
                                                        >
                                                            {row.title}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="mobile-nav-section mobile-nav-account-block">
                                            <h3 className="mobile-nav-heading">ACCOUNT</h3>
                                            <ul className="mobile-nav-list">
                                                {props.isLogin || token ? (
                                                    <>
                                                        <li>
                                                            <Link href={`/${store}/user/dashboard`}>
                                                                <a
                                                                    className="mobile-nav-link"
                                                                    onClick={() => setAddClass(false)}
                                                                >
                                                                    My Account
                                                                </a>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <a
                                                                href="#"
                                                                className="mobile-nav-link"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setAddClass(false);
                                                                    props.handleLogout?.();
                                                                }}
                                                            >
                                                                Log out
                                                            </a>
                                                        </li>
                                                    </>
                                                ) : (
                                                    <li>
                                                        <a
                                                            href="#"
                                                            className="mobile-nav-link"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setAddClass(false);
                                                                showlogin();
                                                            }}
                                                        >
                                                            Login
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        <div className="mobile-nav-view-cart">
                                            <Link href={`/${store}/cart/viewCart`}>
                                                <a
                                                    className="mobile-nav-view-cart-link"
                                                    onClick={() => {
                                                        setAddClass(false);
                                                        props?.updatecartdata?.(true);
                                                    }}
                                                >
                                                    View Cart
                                                    {props?.cartdata?.products?.length > 0 && props?.counts ? (
                                                        <span className="mobile-nav-cart-count"> ({props.counts})</span>
                                                    ) : null}
                                                </a>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </NavBarStyle>
            </div>

            <TemporaryDrawer
                state={countryState?.popUp}
                getData={(section, value) => _setValues(section, value)}
                toggleDrawer={() => setCountryState({ ...countryState, popUp: false })}
                data={['USA', 'Canada', 'Australia', ' New Zealand']}
                section="Country"
            />

            <TemporaryDrawer
                state={languageState?.popUp}
                getData={(section, value) => _setValues(section, value)}
                toggleDrawer={() => setLanguageState({ ...languageState, popUp: false })}
                data={['English']}
                section="Language"
            />

            <ViewCartPopup
                ref={popRef}
                content={{
                    open,
                    setOpen,
                    ...props,
                }}
            />
            <LoginPopup openLoginPopup={openLoginPopup} setOpenLoginPopup={setOpenLoginPopup} />
        </>
    );
};

export default NavBar;
